import { PsNotificationStates } from '../../PsNotificationStates';

export class NotificationSearchRequest {

    _page; // number
    _term; // string
    _limit; // number
    _state; // NotificationStates

    constructor(limit = 100) {
        this._page = 1;
        this._term = '';
        this._limit = limit;
        this._state = PsNotificationStates.ALL;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setState(state) {
        this._state = state;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                limit: this._limit,
                show_only_solved: this._state === PsNotificationStates.SOLVED,
                show_only_unsolved: this._state === PsNotificationStates.NO_SOLVED,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/shared/notification-search/NotificationSearchRequest.js